export const ScrollOptions: ScrollIntoViewOptions = {
    behavior: 'smooth',
    block: 'start',
};
